import React, { useEffect, useState } from "react";
import { TOAST_EVENT, ToastMessage } from "../../utils/toast";
import "../../styles/shared/ToastViewport.css";

const AUTO_DISMISS_MS = 3500;

interface ToastViewportProps {
  className?: string;
  durationMs?: number;
}

const ToastViewport: React.FC<ToastViewportProps> = ({ className, durationMs = AUTO_DISMISS_MS }) => {
  const [toasts, setToasts] = useState<ToastMessage[]>([]);

  useEffect(() => {
    const handleToast = (event: Event) => {
      const customEvent = event as CustomEvent<ToastMessage>;
      const nextToast = customEvent.detail;
      if (!nextToast?.message) {
        return;
      }

      setToasts((current) => [...current.slice(-2), nextToast]);
      window.setTimeout(() => {
        setToasts((current) => current.filter((item) => item.id !== nextToast.id));
      }, durationMs);
    };

    window.addEventListener(TOAST_EVENT, handleToast as EventListener);
    return () => window.removeEventListener(TOAST_EVENT, handleToast as EventListener);
  }, [durationMs]);

  if (toasts.length === 0) {
    return null;
  }

  return (
    <div className={`toast-viewport${className ? ` ${className}` : ""}`} aria-live="polite" aria-atomic="true">
      {toasts.map((toast) => (
        <div key={toast.id} className={`toast-viewport__item toast-viewport__item--${toast.kind}`}>
          <span className="toast-viewport__dot" aria-hidden="true" />
          <p>{toast.message}</p>
        </div>
      ))}
    </div>
  );
};

export default ToastViewport;
